export function fillTemplatePlaceholders(text, params = []) {
  if (!text) return '';
  let result = String(text);
  (params || []).forEach((val, i) => {
    result = result.replace(new RegExp(`\\{\\{${i + 1}\\}\\}`, 'g'), String(val ?? `{{${i + 1}}}`));
  });
  return result;
}

export function buildTemplateDisplayContent(tpl, params = []) {
  if (!tpl) return '';
  const parts = [];
  if (tpl.header_type === 'TEXT' && tpl.header_text) {
    parts.push(fillTemplatePlaceholders(tpl.header_text, params));
  }
  if (tpl.body_text) {
    parts.push(fillTemplatePlaceholders(tpl.body_text, params));
  }
  if (tpl.footer_text) parts.push(String(tpl.footer_text));
  return parts.filter(Boolean).join('\n\n');
}

function normalizeParams(raw) {
  if (Array.isArray(raw)) return raw.map((v) => String(v ?? ''));
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed.map((v) => String(v ?? '')) : [];
    } catch {
      return [];
    }
  }
  return [];
}

function formatSharedContactsContent(raw) {
  const text = String(raw || '').trim();
  if (!text.startsWith('{') && !text.startsWith('[')) return null;
  try {
    const parsed = JSON.parse(text);
    const contacts = Array.isArray(parsed?.contacts)
      ? parsed.contacts
      : (Array.isArray(parsed) ? parsed : null);
    if (!contacts?.length) return null;
    return contacts.map((c) => {
      const name = c?.name?.formatted_name || c?.name?.first_name || 'Contact';
      const phones = Array.isArray(c?.phones)
        ? c.phones.map((p) => p?.phone || p?.wa_id).filter(Boolean)
        : [];
      return phones.length ? `📇 ${name}\n${phones.join(', ')}` : `📇 ${name}`;
    }).join('\n\n');
  } catch {
    return null;
  }
}

export function resolveMessageDisplayContent(message, templatesByName = {}) {
  if (!message) return '';

  const params = normalizeParams(message.template_params);
  const content = message.content;
  const templateName = message.template_name;

  const sharedContacts = formatSharedContactsContent(content);
  if (sharedContacts) return sharedContacts;

  if (message.message_type === 'template' && templateName) {
    const tpl = templatesByName[templateName];
    if (tpl) {
      const rendered = buildTemplateDisplayContent(tpl, params);
      if (rendered) return rendered;
    }
    if (content && content !== templateName && !String(content).startsWith(`${templateName}:`)) {
      return fillTemplatePlaceholders(content, params) || content;
    }
    return content || templateName;
  }

  if (templateName && content === templateName) {
    const tpl = templatesByName[templateName];
    if (tpl) return buildTemplateDisplayContent(tpl, params) || content;
  }

  if (templateName && templatesByName[templateName] && content) {
    const filled = fillTemplatePlaceholders(content, params);
    if (filled && filled !== templateName) return filled;
  }

  return content || '';
}

export function resolveReplyPreview(replyContent, templatesByName = {}, originalMessage = null) {
  if (originalMessage) {
    const resolved = resolveMessageDisplayContent(originalMessage, templatesByName);
    if (resolved) return resolved;
  }
  if (!replyContent) return '';
  const tpl = templatesByName[replyContent];
  if (tpl?.body_text) return tpl.body_text;
  return replyContent;
}

export function resolveTemplateButtons(message, templatesByName = {}) {
  if (!message?.template_name) return [];
  const tpl = templatesByName[message.template_name];
  if (!tpl?.buttons?.length) return [];
  const params = normalizeParams(message.template_params);
  const bodyParamCount = Number(tpl.param_count || 0);
  const buttonParams = params.slice(bodyParamCount);

  return tpl.buttons.map((btn) => {
    const type = String(btn.type || '').toUpperCase();
    let url = btn.url ? String(btn.url) : undefined;
    if (url && /\{\{\d+\}\}/.test(url)) {
      let cursor = 0;
      url = url.replace(/\{\{\d+\}\}/g, () => buttonParams[cursor++] || '');
    }
    return {
      type,
      text: String(btn.text || 'Button'),
      url,
      phone_number: btn.phone_number ? String(btn.phone_number) : undefined,
    };
  });
}
